import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();
$(function() {

	const amenitiesBlock = {

		init: function() {
			this.cacheDOM();
			this.sliderInit();
		},

		cacheDOM: function() {
			this.$slider = $('.js-amenities-slider');
		},

		sliderInit: function() {
			if (!this.$slider.length) {
				return;
			}

			const sliderConfig = {
				slidesToShow: 5,
				autoplaySpeed: 3000,
				responsive: [
					{
						breakpoint: 1199,
						settings: {
							slidesToShow: 4
						}
					},
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 3
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 400,
						settings: {
							slidesToShow: 1
						}
					}
				]
			};

			sliders.initializeSlider('.js-amenities-slider', sliderConfig);
		},

	};

	amenitiesBlock.init();

});
